export default {
    stages: [
        'Register',
        'Personal',
        'HomeAddress',
        'Subscription',
        'Payment',
        'Confirmation',
        'Success'
    ],
    
    subscriptions: {},
    product: null,
    payment: {
        jwtToken: '',
        cbToken: '',
        cardErrors: {},
        card: {}
    },
    use_home_as_billing: true,
    user: {
        first_name: '',
        profile: {},
        subscription: {}
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Enrolment/state.js